import { Component, OnInit } from '@angular/core';
import { isUndefined } from 'util';
import { MatDialogRef } from "@angular/material";
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { RestApiService } from "../shared/restApiServices/restapi.service";
import { ShowToastyService } from "../shared/services/showToastyService";

declare var require: any;
var countriesStateJSON = require("../../assets/StateCountry.json");

@Component({
  selector: 'app-update-billing-info-modal',
  templateUrl: './update-billing-info-modal.component.html',
  styleUrls: ['./update-billing-info-modal.component.css']
})
export class UpdateBillingInfoModalComponent implements OnInit {

  companyName:string = '';
  gstNumber:string = '';
  address:any;
  Street1:string = '';
  Locality1:string = '';
  City1:string = '';
  Zipcode1:string = '';
  state1:string = '';
  Country1:string = '';

  Street:string = '';
  Locality:string = '';
  City:string = '';
  Zipcode:string = '';
  state:string = '';
  Country:string = '';

  companyNameEmpty:string = '';
  gstNoEmpty:string = '';
  addressEmpty:string = '';

  countryControl = new FormControl();
  myControl = new FormControl();
  filteredCountries: Observable<any[]>;
  filteredState: Observable<any[]>;

  countriesStateJSON = countriesStateJSON;
  statesJSON:any;

  constructor(private dialogRef:MatDialogRef<UpdateBillingInfoModalComponent>, private restApiService:RestApiService, private showToastyService:ShowToastyService) {

    this.restApiService.getBillingDetails().subscribe(res=>{
      if(res.success == true){
        // res['address']['City'])
        this.companyName = res['company_name'];
        this.gstNumber = res['GSTIN'];
        if(Object.getOwnPropertyNames(res.address).length !== 0)
        {
          this.Street1 = res['address']['Street'];
          this.Locality1 = res['address']['Locality'];
          this.City1 = res['address']['City'];
          this.Zipcode1 = res['address']['Zipcode'];
          this.state1 = res['address']['state'];
          this.myControl.setValue(this.state1);
          this.Country1 = res['address']['Country'];
          this.countryControl.setValue(this.Country1);
          this.selectCountry(this.Country1);
        }
        else{
          this.countryControl.setValue('India');
          this.selectCountry('India');
        }
      }
    })
   }

  ngOnInit() {
    this.filteredCountries = this.countryControl.valueChanges
    .pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value['countryName']),
      map(name => name ? this._filter(name) : this.countriesStateJSON.slice())
    );
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.countriesStateJSON.filter(option => option.countryName.toLowerCase().indexOf(filterValue) === 0);
  }

  selectCountry(country){
    this.Country1 = country;
    let index = this.countriesStateJSON.filter(option => option.countryName.toLowerCase().indexOf(country.toLowerCase()) === 0)
    this.statesJSON = index[0].regions;
    this.filteredState = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value['name']),
      map(name => name ? this._filterState(name) : this.statesJSON.slice())
    );
  }

  private _filterState(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.statesJSON.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  selectState(state){
    this.state1 = state;
  }

  proceed(){
    this.companyNameEmpty = '';
    this.gstNoEmpty = '';
    this.addressEmpty = '';

    if(this.companyName==null || isUndefined(this.companyName) || this.companyName=="")
    {
      this.companyNameEmpty = "on-error";
      return;
    }
    else if(this.Street1==null || isUndefined(this.Street1) || this.Street1=="")
    {
      this.Street = "on-error";
      return;
    }
    else if(this.Locality1==null || isUndefined(this.Locality1) || this.Locality1=="")
    {
      this.Locality = "on-error";
      return;
    }
    else if(this.City1==null || isUndefined(this.City1) || this.City1=="")
    {
      this.City = "on-error";
      return;
    }
    else if(this.Zipcode1==null || isUndefined(this.Zipcode1) || this.Zipcode1=="")
    {
      this.Zipcode = "on-error";
      return;
    }
    else if(this.state1==null || isUndefined(this.state1) || this.state1=="")
    {
      this.state = "on-error";
      return;
    }
    else if(this.Country1==null || isUndefined(this.Country1) || this.Country1=="")
    {
      this.Country = "on-error";
      return;
    }
    else {
      this.companyNameEmpty = '';
      this.gstNoEmpty = '';
      this.addressEmpty = '';
      this.address = {
        "companyName": this.companyName,
        "Street": this.Street1,
        "Locality":this.Locality1,
        "City": this.City1,
        "Zipcode": this.Zipcode1,
        "state": this.state1,
        "Country": this.Country1
      };
      this.restApiService.updatebillinginfo(this.companyName, this.address).subscribe(res=>{
          if(res.success == true){
            this.showToastyService.success('Updated','Your billing information was successfully updated.');
            this.dialogRef.close();
          }
          else{
            this.showToastyService.failure('Error','Please Try Again');
            this.dialogRef.close();
          }
      })
    }

  }

  close(){
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/update-billing-info-modal/update-billing-info-modal.component.ts